import numeral from "numeral";
import { decr, encr } from "./crypto"
import Cookies from 'js-cookie';
import moment from "moment";
import { v4 as uuidv4 } from 'uuid';
import i18n from "../components/i18n/lang";

export const getPercentData = (lengthData, lengthDataTotal) => {

	return lengthData * 100 / lengthDataTotal
}
export const checkMorePage = (lengthData, perPage, lengthDataTotal) => {
	return lengthData >= perPage && perPage < lengthDataTotal
}

export const setLocalStorage = (key, data) => {
	return localStorage.setItem(key, encr(JSON.stringify(data)))

}
export const getLocalStorage = (key) => {
	return localStorage.getItem(key) ? JSON.parse(decr(localStorage.getItem(key))) : ""

}
export const clearLocalStorage = (key) => {
	return localStorage.clear(key)

}

export const handleSetCookie = (key, value, expires) => {
	Cookies.set(key, encr(JSON.stringify(value)), { expires: expires });
};

export const handleGetCookie = (key) => {
	return Cookies.get(key) ? JSON.parse(decr(Cookies.get(key))) : "";
};

export const handleDeleteCookie = (key) => {
	Cookies.remove(key);
};
export const handleInvalid = (event, text) => {
	// event.preventDefault(); // Prevent the browser's default validation tooltip
	event.target.setCustomValidity(text);
};
export const calculateAgeByDate = (date, sign) => {
	if (!date) return;
	const birth = new Date(date);
	const today = new Date(sign);
	let age = today.getFullYear() - birth.getFullYear();
	const monthDiff = today.getMonth() - birth.getMonth();
	const dayDiff = today.getDate() - birth.getDate();
	if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
		age--;
	}

	return age
};

export const handleInput = (event) => {
	event.target.setCustomValidity(''); // Clear the custom error message when user starts typing
};
export const FormatCurrencys = (amount) => {
	const formattedAmount = numeral(amount).format("0,0");
	return formattedAmount
};

export function toArraySelect(items, keyName, keyValue) {
	return items.map((item) => ({ label: item[keyName], value: item[keyValue] }))

}
export function isLa() {
	return localStorage.getItem('lang') == 'la'

}
export function FormatCurrency({ amount }) {
	const formattedAmount = numeral(amount).format("0,0");
	return `${formattedAmount}`;
}

export function calculateTotalPages(totalItems, itemsPerPage) {
	return Math.ceil(totalItems / itemsPerPage);
}

export function dateToString(date, formatString = 'DD/MM/YYYY') {
	try {
		return moment.utc(date).format(formatString)
	} catch (error) {
		return '-';
	}
}

// export function encodeBase64(text) {
// 	return btoa(new TextEncoder().encode(text.replace(/%([0-9A-F]{2})/g, function (_, p1) {
// 		return String.fromCharCode("0x" + p1);
// 	})).reduce((acc, byte) => acc + String.fromCharCode(byte), "")).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
// };

// export function decodeBase64(text) {
// 	return new TextDecoder().decode(Uint8Array.from(atob(text), c => c.charCodeAt(0)));
// };
export function decodeBase64(str) {
	if (!str) return null;

	// ถ้ามี URL encoding มาก่อน (จาก encodeURIComponent)
	try {

	} catch (e) {
		console.warn("decodeURIComponent error:", e);
	}

	// ถ้าเป็น base64 url-safe แก้ให้เป็น base64 ปกติ
	let base64 = str.replace(/-/g, "+").replace(/_/g, "/");

	// // เติม padding =
	while (base64.length % 4 !== 0) {
		base64 += "=";
	}

	try {
		return decodeURIComponent(
			atob(base64)
				.split("")
				.map((c) => "%" + c.charCodeAt(0).toString(16).padStart(2, "0"))
				.join(""));
	} catch (e) {
		console.error("atob error:", e, str);
		return null;
	}
}
export function encodeBase64(str) {
	return btoa(
		encodeURIComponent(str)
			.replace(/%([0-9A-F]{2})/g, function (_, p1) {
				return String.fromCharCode("0x" + p1);
			})
	).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

export function playSound() {
	// return new Promise((resolve) => {
	// 	const sound = new Audio("/sounds/notification_sound.mp3");
	// 	sound.play();
	// 	sound.onended = resolve;
	// });

	return new Promise((resolve) => {
		const sound = new Audio("/sounds/notification_sound.mp3");
		sound.oncanplaythrough = () => {
			sound.play()
				.then(() => {
					sound.onended = resolve;
				})
				.catch((error) => {
					console.error("Playback failed:", error);
				});
		};

		sound.load(); // โหลดไฟล์เสียงล่วงหน้า
	});
}

export function displayUrl(img) {

	return process.env.REACT_APP_SERVER_URL + "/view/display" + img;
};


export function getDeviceId() {
	let deviceId = localStorage.getItem('device_id');
	if (!deviceId) {
		deviceId = uuidv4();
		localStorage.setItem('device_id', deviceId);
	}
	// console.log(deviceId)
	return deviceId;
};
export function convertStringToJson(string) {
	try {
		return JSON.parse(string);
	} catch (error) {
		return []
	}
};

export function checkPermissionByPath(path, roleId) {
	try {
		const adminMenu = JSON.parse(localStorage.getItem('adminMenu') || '[]');

		return adminMenu
			.flatMap(item => item.children || [])
			.some(child => child.routePath === path && (child.permissions || []).includes(roleId));
	} catch {
		return false;
	}
}
// utils/getImageSize.js
export const getImageSize = (url) => {
	return new Promise((resolve) => {
		const img = new Image();
		img.onload = function () {
			resolve({ width: this.width, height: this.height });
		};
		img.onerror = function () {
			resolve({ width: 1024, height: 768 }); // fallback
		};
		img.src = url;
	});
};

export const relation = () => {
	const data = [
		{ label: i18n.t('relation.father'), value: '1' },
		{ label: i18n.t('relation.mother'), value: '2' },
		{ label: i18n.t('relation.husband'), value: '3' },
		{ label: i18n.t('relation.wife'), value: '4' },
		{ label: i18n.t('relation.child'), value: '5' },
		{ label: i18n.t('relation.brother'), value: '6' },
		{ label: i18n.t('relation.sister'), value: '7' },
		{ label: i18n.t('relation.grandfather'), value: '8' },
		{ label: i18n.t('relation.grandmother'), value: '9' },
		{ label: i18n.t('relation.grandchild'), value: '10' },
		{ label: i18n.t('relation.youngerBrother'), value: '11' },
		{ label: i18n.t('relation.daughter-in-law'), value: '12' },
		{ label: i18n.t('relation.son-in-law'), value: '13' },
		{ label: i18n.t('relation.uncle'), value: '14' },
		{ label: i18n.t('relation.aunt'), value: '15' },
		{ label: i18n.t('relation.naSao'), value: '16' },
		{ label: i18n.t('relation.naBao'), value: '17' },
		{ label: i18n.t('relation.nongSao'), value: '18' },
		{ label: i18n.t('relation.nongSaiy'), value: '19' },



	];
	return data;
};
export const getLaosDateTime = () => {
	return new Date().toLocaleString('sv-SE', {
		timeZone: 'Asia/Vientiane',
		hour12: false,
	}).replace('T', ' ');
};
export const parseDbValueToArray = (value) => {
	try {
		// ຖ້າ value ເປັນ null / undefined / ວ່າງ
		if (value === null || value === undefined || value === '') {
			return [];
		}

		// ຖ້າ DB ສົ່ງມາເປັນ array ຢູ່ແລ້ວ
		if (Array.isArray(value)) {
			return value.map(Number);
		}

		// ຖ້າເປັນ number ເຊັ່ນ 6000
		if (typeof value === 'number' && value > 0) {
			return [value];
		}

		// ຖ້າເປັນ string
		if (typeof value === 'string') {
			const text = value.trim();

			// ກໍລະນີ string ເປັນ array ເຊັ່ນ "[2000,3000]"
			if (text.startsWith('[') && text.endsWith(']')) {
				const parsed = JSON.parse(text);
				return Array.isArray(parsed) ? parsed.map(Number) : [];
			}

			// ກໍລະນີ string ເປັນເລກ ເຊັ່ນ "6000"
			const numberValue = Number(text);
			if (!isNaN(numberValue) && numberValue > 0) {
				return [numberValue];
			}
		}

		return [];
	} catch (error) {
		console.error('parseDbValueToArray error:', error);
		return [];
	}
};
export const calculateAge = (date) => {
	if (!date) return;
	const birth = new Date(date);
	const today = new Date();
	let age = today.getFullYear() - birth.getFullYear();
	const monthDiff = today.getMonth() - birth.getMonth();
	const dayDiff = today.getDate() - birth.getDate();
	if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
		age--;
	}

	return age
};
export const causeDeadList = () => {
	const data = [
		{ label: i18n.t('claim.causeList.personal'), value: '1' },
		{ label: i18n.t('claim.causeList.accident'), value: '2' },
		{ label: i18n.t('claim.causeList.killYourself'), value: '4' },
		{ label: i18n.t('claim.causeList.other'), value: '3' },
	];
	return data;
};
export const methodReceiveMoneyList = () => {
	const data = [
		{ label: i18n.t('claim.methodReceiveMoneyList.heir'), value: '1' },
		{ label: i18n.t('claim.methodReceiveMoneyList.agent'), value: '2' },

	];
	return data;
};
export const heirList = () => {
	const data = [
		{ label: i18n.t('claim.methodReceiveMoneyList.heir1'), value: '0' },
		{ label: i18n.t('claim.methodReceiveMoneyList.heir2'), value: '1' },

	];
	return data;
};
export const bankList = () => {
	const data = [
		{ label: i18n.t('bank.bcel'), value: 'BCEL' },
		{ label: i18n.t('bank.ldb'), value: 'LDB' },
		{ label: i18n.t('bank.jdb'), value: 'JDB' },
		{ label: i18n.t('bank.lvb'), value: 'LVB' },
		{ label: i18n.t('bank.apb'), value: 'APB' },
	];
	return data;
};